import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { StatusBadge } from '@/components/shared/StatusBadge';
import { Bell, Check } from 'lucide-react';
import { toast } from 'sonner';

export default function NotificationsPage() {
  const [notifications, setNotifications] = useState([]);
  const [unread, setUnread] = useState(0);

  const fetchData = async () => {
    try {
      const res = await api.get('/org/notifications/my');
      setNotifications(res.data.data || []);
      setUnread(res.data.unread_count || 0);
    } catch (e) { toast.error('Failed to load notifications'); }
  };
  useEffect(() => { fetchData(); }, []);

  const markRead = async (id) => {
    try { await api.post(`/org/notifications/${id}/read`); fetchData(); } catch (e) {}
  };
  const markAllRead = async () => {
    try { await api.post('/org/notifications/read-all'); fetchData(); toast.success('All marked as read'); } catch (e) {}
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between">
        <div><h1 className="text-2xl font-bold tracking-tight">Notifications</h1><p className="text-muted-foreground mt-1">{unread} unread</p></div>
        {unread > 0 && <Button variant="outline" onClick={markAllRead} data-testid="mark-all-read"><Check className="h-4 w-4 mr-2" /> Mark all read</Button>}
      </div>
      {notifications.length === 0 ? (
        <Card><CardContent className="py-12 text-center"><Bell className="h-12 w-12 text-muted-foreground/30 mx-auto mb-4" /><p className="text-muted-foreground">No notifications</p></CardContent></Card>
      ) : (
        <div className="space-y-2">
          {notifications.map(n => (
            <Card key={n.id} className={`transition-colors ${!n.is_read ? 'border-primary/20 bg-accent/20' : ''}`}>
              <CardContent className="p-4 flex items-start justify-between gap-4">
                <div className="flex-1">
                  <p className={`text-sm ${!n.is_read ? 'font-medium' : ''}`}>{n.title}</p>
                  <p className="text-xs text-muted-foreground mt-1">{n.message}</p>
                  <div className="flex items-center gap-2 mt-2">
                    <StatusBadge status={n.type} />
                    <span className="text-[10px] text-muted-foreground">{new Date(n.created_at).toLocaleString()}</span>
                  </div>
                </div>
                {!n.is_read && <Button variant="ghost" size="sm" onClick={() => markRead(n.id)} className="text-xs">Mark read</Button>}
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
